import { useState } from 'react'
import styled from 'styled-components'
import { H2Alt, H3, TextBody, H1 } from 'src/styles/Typography'
import SvgArrowRight from '../icons/ArrowRight'
import Link from 'next/link'
import CareersFormPortal from './CareersFormPortal'
import { positions } from './Positions'

export default function CareerOpenings({ openings }) {
  const [close, setClose] = useState(true)
  const [pos, setPos] = useState('')

  return (
    <Wrapper>
      <CareerTitleContainer>
        <H2Alt>Join Our Team</H2Alt>
        <TextBody>
          Explore our job opportunities and find something that works for you.
        </TextBody>
      </CareerTitleContainer>
      <SmallWrap>
        {openings.map((job, index) => {
          return (
            <OpeningsContainer key={`${job.title}-${index}`}>
              <JobHeading>
                <ClickWrapper onClick={() => setClose((s) => !s && setPos(job.title))}>
                  <H3>{job.title}</H3>
                </ClickWrapper>
                <TextBody>{job.location}</TextBody>
              </JobHeading>
              {!close && (
                <CareersFormPortal setClose={setClose} positionList={positions} />
              )}
              <IconWrap>
                <SvgArrowRight />
              </IconWrap>
            </OpeningsContainer>
          )
        })}
      </SmallWrap>
    </Wrapper>
  )
}

const CareerTitleContainer = styled.div`
  padding: 3em 6em;

  ${TextBody} {
    margin: 0 auto;
  }

  ${H2Alt} {
    margin: 0 auto;
    color: ${({ theme }) => theme.colors.brand.darker};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: flex;
    flex-direction: column;
    text-align: left;
    padding: 2em;
    min-width: 300px;
  }
`

const OpeningsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px;
  border-bottom: 1px solid #e4ebed;

  ${TextBody} {
    margin: 0 auto;
    margin-bottom: 15px;
  }
  ${H3} {
    margin: 0;
    color: ${({ theme }) => theme.colors.brand.darker};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: flex;
    margin: 0 auto;
    text-align: left;
    padding: 0;
    min-width: 300px;
  }
`

const SmallWrap = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 600px;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    min-width: 200px;
  }
`

const IconWrap = styled.div`
  display: flex;
  transform: translate(0, 20%);
`
const JobHeading = styled.div``

const Wrapper = styled.div`
  padding: 3em;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  flex-wrap: wrap;
  background-color: #fafafa;
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: flex;
    margin: 0 auto;
    text-align: left;
    padding: 0;
    padding-bottom: 2em;
  }
`

const ClickWrapper = styled.button`
  border: none;
  background: none;
  padding: 0;
  margin: 0;
`

const FormWrap = styled.div`
  width: 600px;
`
